import { SET_CLIENT_DATA } from './constants';

export const setClientData = data => dispatch =>
    dispatch({
        type: SET_CLIENT_DATA,
        payload: data,
    });
